import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService} from '../../../login/login.service';

import { UpdateNotificationService} from 'app/layout/notifications-page/update-notification.service'
;

import {Notification} from 'app/layout/notifications-page/notification';

    import { from } from 'rxjs/observable/from';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {


name: string ;
agent:  any ;
hasNotifications:boolean =false;

notificationCount:number=0;
ticketCount:number=0;


 
notificationsCount: Array<number>;




    constructor(private loginService:  LoginService, private translate: TranslateService, public notificationService: UpdateNotificationService, public router: Router) {
     
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd && window.innerWidth <= 992) {
                this.toggleSidebar();
            }
        });


        this.notificationsCount = new Array <number>(5);
     



        //this.notificationService.notificationsUpdateEvent.subscribe( this.UpdateNotification());
    

        this.loginService.profileUpdateEvent.subscribe( 

              agentData => {

                this.UpdateNotification( agentData);




            }


        );
        
    }

    UpdateNotification ( agentProfile: any) {

       
        for ( var i=0; i< 5; i++) {
          
            this.notificationsCount[i]=0;
        
        }
      

let notification:Notification;
this.notificationCount=0;



        for ( let i=0; i< agentProfile.notifications.length; i++) {
            notification = agentProfile.notifications[i] as Notification;

            if ( !notification.notificationCleared) {
                this.notificationCount++;

                this.notificationsCount[notification.notificationType]++;
 
            }

           

        }


        if ( this.notificationCount>0) {
      
            this.hasNotifications=true;
        
            
        
          }

    }

    ngOnInit() {


   // console.log(this.login.agent);
 Promise.resolve(this.loginService.getAgentProfile()).then ( data => this.name= data.name ) ;

         
 if ( this.loginService.agent.tickets.length>0 ||this.loginService.agent.notifications.length>0 ) {

    this.ticketCount= this.loginService.agent.tickets.length;

    let count=0;

    let notifies = this.loginService.agent.notifications;



    this.notificationsCount = new Array <number>(5);

    for ( var i=0; i< 5; i++) {
      
        this.notificationsCount[i]=0;

    
    }
  

    for (let i=0; i< notifies.length; i++ ) {

        if  ( !notifies[i].notificationCleared) {
            count++;
            this.notificationsCount[notifies.notificationType]++;
        }

       
    

  }


  this.notificationsCount[Notification.HELP_REQUEST] =  this.loginService.agent.tickets.length;
  
  



   

  if ( count>0) {
      
    this.hasNotifications=true;

    this.notificationCount=count;

  }

 }


    }
 

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('push-right');
    }

    rltAndLtr() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('rtl');
    }

    onLoggedout() {
        localStorage.removeItem('isLoggedin');
    }

    changeLang(language: string) {
        this.translate.use(language);
    }

    GetStyle() {

        let isSemi =false;
        let transform =   'translateX(50%)';
    
        return {
            'bottom': '75%',
            'left': '75%',
            'transform': transform,
            '-moz-transform': transform,
            '-webkit-transform': transform,
            'font-size': 15 + 'px',
            
    };
}

GetNotificationStyle () {
if ( this.hasNotifications) {
    return {

        'color':'#ffffff'
        
    }
}
    return {};

}

 
}



// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/shared/components/header/header.component.ts